export default __webpack_public_path__ + "static/media/apple-tv-screen-on-hover.458fbe1b.jpg";